<template>
  <div class="question-answer-preview">

    <!-- MultiMatching -->
    <div v-if="this.questionType === 'MultiMatching'" class="multi-matching">
      <div style="font-weight: bold; margin-bottom: 8px;">Nhóm B (Kho Lựa Chọn)</div>
      <div v-for="(item, index) in answersTemp.list" :key="'pool-'+index" style="margin-bottom: 8px;">
        {{ index + 1 }}.
        <img v-if="isImageUrl(item)" :src="item | media" style="max-height: 50px;" />
        <span v-else>{{ item }}</span>
      </div>

      <div style="font-weight: bold; margin-top: 16px; margin-bottom: 8px;">Nhóm A (Câu Hỏi) -> Đáp án</div>
      <div v-for="(item, index) in answersTemp.classificationFields" :key="'target-'+index" style="margin-bottom: 8px;">
        <img v-if="isImageUrl(item)" :src="item | media" style="max-height: 50px;" />
        <span v-else>{{ item }}</span>
        <span> &nbsp; <strong>&#8594;</strong> &nbsp; </span>
        <span v-if="rightTemp[index] !== undefined">Lựa chọn {{ rightTemp[index] + 1 }}</span>
        <span v-else><em>Chưa chọn</em></span>
      </div>

      <div class="answer md-layout-item md-size-100 answer-item" style="margin-top: 16px;">
        <strong>Câu trả lời của học sinh
          <span v-if="studentAnswer" :style="studentAnswer.isRight ? 'color: #28a745' : 'color: #c82333'">
            {{ studentAnswer.isRight ? '(Đúng): ' : '(Sai): ' }}
          </span>
          <span v-else style="color: #c82333">: Không làm</span>
        </strong>
        <div v-if="studentAnswer && studentAnswer.answer" style="padding-left: 15px">
          <div v-for="(ans, aIdx) in studentAnswer.answer" :key="'stu-ans-'+aIdx">
            {{ aIdx + 1 }}. <span :style="ans === answersTemp.list[rightTemp[aIdx]] ? 'color: #28a745' : 'color: #c82333'">{{ ans }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================ -->
    <!-- DaDImageLabeling Question Type -->
    <!-- ============================================ -->
    <div
      v-if="this.questionType === 'DaDImageLabeling'"
      class="dad-image-labeling"
    >
      <!-- Image preview with labels -->
      <div v-if="questionImageUrl" class="dad-image-container">
        <div class="image-wrapper">
          <img
            :src="questionImageUrl | media"
            alt="Labeling Image"
            class="dad-image"
          />
          <div
            v-for="(item, index) in rightTemp"
            :key="`label-${index}`"
            class="label-rect"
            :style="{
              left: item.x + '%',
              top: item.y + '%',
              width: item.w + '%',
              height: item.h + '%'
            }"
          >
            <span class="label-text">{{ item.label }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================ -->
    <!-- FillInTheBlanks Question Type -->
    <!-- ============================================ -->
    <div v-if="this.questionType === 'FillInTheBlanks'" class="fill-in-blanks">
      <!-- Preview mode -->
      <div class="fill-blanks-preview">
        <div
          v-for="(lineParts, lineIndex) in getFillBlanksPreviewParts()"
          :key="`line-${lineIndex}`"
          class="preview-line"
        >
          <span
            v-for="(part, partIndex) in lineParts"
            :key="`part-${lineIndex}-${partIndex}`"
            class="part-wrapper"
          >
            <span class="text-part">{{ part }}</span>
            <span v-if="partIndex < lineParts.length - 1" class="blank-slot">
              {{ getBlankAnswerDisplay(lineIndex, partIndex) }}
            </span>
          </span>
        </div>
      </div>
    </div>

    <!-- MultiChoice, Dropdown Question Types -->
    <div v-if="['MultiChoice', 'Dropdown'].includes(this.questionType)" class="multiple-choice">
      <div class="answers md-layout md-gutter">
        <div
          class="answer md-layout-item md-size-50 answer-item"
          v-for="(ans, index) in answersTemp"
          :key="index"
        >
          <md-radio v-model="rightTemp" :value="index" disabled />
          <BaseInputQuestionText v-model="answersTemp[index]" disabled />
        </div>
      </div>
    </div>

    <!-- MultiSelect Question Type -->
    <div v-if="this.questionType === 'MultiSelect'" class="multi-select">
      <div class="answers md-layout md-gutter">
        <div
          class="answer md-layout-item md-size-50 answer-item"
          v-for="(ans, index) in answersTemp"
          :key="index"
        >
          <md-checkbox
            :value="index"
            :checked="rightTemp && rightTemp[index] === true"
            disabled
          />
          <BaseInputQuestionText v-model="answersTemp[index]" disabled />
        </div>
      </div>
    </div>

    <div v-if="this.questionType === 'ShortAnswer'" class="short-answer">
      <div class="answers md-layout md-gutter">
        <div
          class="answer md-layout-item md-size-50 answer-item"
          v-for="(ans, index) in rightTemp"
          :key="index"
        >
          <BaseInputQuestionText
            v-model="rightTemp[index]"
            :suffixIcon="''"
            disabled
          />
        </div>
      </div>
    </div>

    <div v-if="this.questionType === 'StringSorting'" class="string-sorting">
      <div class="answers">
        <div class="answer answer-item">
          <BaseInputQuestionText v-model="rightTemp" disabled />
        </div>
      </div>
    </div>

    <div v-if="this.questionType === 'CompleteSentence'" class="speaking">
      <div class="answers">
        <div class="answer answer-item">
          <div class="tag-list">
            <template v-for="(item, index) in answersTemp.phrase.split(' ')">
              <span
                class="classification-tag"
                :key="index"
                :style="
                  index === rightTemp[0]
                    ? 'background-color: #1CAB36; color: white;'
                    : 'margin-right: 5px'
                "
                >{{ item }}</span
              >
              <span
                :key="index"
                v-if="index === rightTemp[0] && fakeChoices && fakeChoices[0]"
              >
                ||
              </span>
              <span
                :key="index"
                class="classification-tag"
                style="
                  background-color: #ff5252;
                  color: white;
                  margin-right: 5px;
                "
                v-if="index === rightTemp[0] && fakeChoices && fakeChoices[0]"
                >{{ fakeChoices[0] }}
              </span>
            </template>
          </div>
        </div>

        <div class="note" style="padding-top: 14px; font-size: 12px">
          <span style="font-weight: bold">Chú ý: </span> Dạng bài này là lựa
          chọn giữa đáp án đúng và đáp án sai.
        </div>
      </div>
    </div>

    <div v-if="this.questionType === 'Speaking'" class="speaking">
      <div class="answers">
        <div class="answer answer-item">Phát âm từ : {{ rightTemp }}</div>
      </div>
    </div>

    <div v-if="this.questionType === 'Classification'" class="classification">
      <div class="answers md-layout md-gutter">
        <div class="classification-fields md-layout-item answer-item">
          <BaseInputQuestionSelect
            key="select1"
            v-model="answersTemp.classificationFields"
            :multiple="true"
            :allowCreate="true"
            :filterable="true"
            :createTag="true"
            disabled
            style="width: 100%"
          />
        </div>
      </div>

      <div class="answers md-layout md-gutter">
        <div class="classification-fields md-layout-item answer-item">
          <BaseInputQuestionSelect
            key="select2"
            v-model="answersTemp.list"
            :multiple="true"
            :allowCreate="true"
            :filterable="true"
            :createTag="true"
            disabled
            style="width: 100%"
          />
        </div>
      </div>

      <div class="answers">
        <div
          class="classification-fields answer-item"
          v-for="(item, index) in answersTemp.classificationFields"
          :key="`classification-item-${index}`"
        >
          <span class="tag-list">
            <div class="classification-tag" v-html="item"></div>
          </span>
          <BaseInputQuestionSelect
            v-model="rightTemp[index]"
            :multiple="true"
            :allowCreate="false"
            :filterable="true"
            :createTag="true"
            disabled
            :options="
              answersTemp.list
                ? answersTemp.list.map((ans, index) => {
                    return { _id: index, name: ans }
                  })
                : []
            "
            style="width: 100%"
          />
        </div>
      </div>
    </div>

    <div v-if="this.questionType === 'UnderlineWord'" class="underline-word">
      <div class="answers">
        <div
          v-if="answersTemp.type === 'word' && answersTemp.phrase"
          class="answer answer-item underline-right"
        >
          <span
            class="underline-tag"
            v-for="(item, index) in answersTemp.phrase.split(' ')"
            :key="`underline-tag-${index}`"
            :class="rightTemp.includes(index) ? 'selected' : ''"
          >
            {{ item }}
          </span>
        </div>

        <div
          v-if="answersTemp.type === 'character' && answersTemp.phrase"
          class="answer answer-item underline-right"
        >
          <span
            class="underline-tag"
            v-for="(item, index) in answersTemp.phrase.split('')"
            :key="`underline-tag-${index}`"
            :class="rightTemp.includes(index) ? 'selected' : ''"
          >
            {{ item }}
          </span>
        </div>
      </div>
    </div>

    <div v-if="this.questionType === 'Matching' || this.questionType === 'Duo'" class="matching">
      <div class="answers md-layout md-gutter" style="padding-bottom: 12px">
        <div class="md-layout-item md-size-45 col-header">Đáp án</div>
        <div class="md-layout-item md-size-45 col-header">
          Câu trả lời của học sinh
        </div>
      </div>

      <div
        v-for="(item, index) in rightTemp"
        :key="index"
        class="md-layout md-gutter"
      >
        <div class="matching-fields md-layout-item md-size-45 answer-item">
          <img
            v-if="isImageUrl(answersTemp.classificationFields[index])"
            style="width: 100px"
            :src="answersTemp.classificationFields[index] | media"
          />
          <span v-else>{{ answersTemp.classificationFields[index] }}</span>
          <span
            >&nbsp;&nbsp;&nbsp;&nbsp;&lt;===========&gt;&nbsp;&nbsp;&nbsp;&nbsp;</span
          >
          <img
            v-if="isImageUrl(rightTemp[index])"
            style="width: 100px"
            :src="rightTemp[index] | media"
          />
          <span v-else>{{ rightTemp[index] }}</span>
        </div>

        <div
          v-if="studentAnswer"
          class="classification-fields md-layout-item md-size-35 answer-item"
          :style="
            studentAnswer.answer[index] == rightTemp[index]
              ? 'color: #28a745'
              : 'color: #c82333'
          "
        >
          <!-- {{ studentAnswer.answer[index] }} -->
          <img
            v-if="isImageUrl(studentAnswer.answer[index])"
            style="width: 100px"
            :src="studentAnswer.answer[index] | media"
          />
          <span v-else>{{ studentAnswer.answer[index] }}</span>
        </div>
      </div>
    </div>

    </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  components: {},
  props: {
    questionImageUrl: {
      type: [String, null],
      default: null
    },
    answers: {
      type: [Array, Object],
      default: () => []
    },
    rightAnswer: {
      type: [Number, String, Array],
      default: () => ''
    },
    fakeChoices: {
      type: [Array, Object],
      default: () => []
    },
    questionType: {
      type: String,
      default: () => ''
    },
    studentAnswer: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(['eClass', 'config', 'googleDrive'])
  },
  data() {
    return {
      lodash: _,
      rightTemp: '',
      answersTemp: '',
      uploadLoading: {
        answersTemp: {},
        rightTemp: {}
      }
    }
  },
  watch: {
    rightAnswer: {
      handler() {
        this.rightTemp = _.cloneDeep(this.rightAnswer)
      },
      immediate: true,
      deep: true
    },
    answers: {
      handler() {
        this.answersTemp = _.cloneDeep(this.answers)
      },
      immediate: true,
      deep: true
    }
  },
  created() {},
  methods: {
    getGlobalBlankIndex(lineIndex, partIndex) {
      const text = this.answersTemp || ''
      const lines = text.split(/\s*\|n\|\s*/)
      let globalBlankIndex = 0

      for (let i = 0; i < lineIndex; i++) {
        const blanksInLine = (lines[i].match(/\[\[\]\]/g) || []).length
        globalBlankIndex += blanksInLine
      }
      globalBlankIndex += partIndex

      return globalBlankIndex
    },

    getFillBlanksPreviewParts() {
      const text = this.answersTemp || ''
      const lines = text.split(/\s*\|n\|\s*/)
      return lines.map((line) => {
        const parts = line.split(/\[\[\]\]/)
        return parts
      })
    },

    getBlankAnswerDisplay(lineIndex, partIndex) {
      const text = this.answersTemp || ''
      const lines = text.split(/\s*\|n\|\s*/)
      let globalBlankIndex = 0

      for (let i = 0; i < lineIndex; i++) {
        const blanksInLine = (lines[i].match(/\[\[\]\]/g) || []).length
        globalBlankIndex += blanksInLine
      }
      globalBlankIndex += partIndex

      const answers = this.rightTemp?.[globalBlankIndex]
      if (answers && answers.length > 0) {
        return answers.join(' / ')
      }
      return '________'
    },

    isImageUrl(string) {
      if (!string || typeof string !== 'string') return false

      if (string.startsWith('/')) {
        return /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(string)
      }

      if (string.startsWith('http')) {
        try {
          const url = new URL(string)
          return /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(url.pathname)
        } catch {
          return false
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.question-answer-preview {
  padding-top: 12px;
  .add-btn {
    display: flex;
    align-items: center;
    color: #1cab36;
    cursor: pointer;
    padding-bottom: 12px;

    .label {
      font-weight: bold;
    }

    .add-circle {
      padding: 0px;
      background: #1cab36;
      border-radius: 50%;
      margin-right: 8px;
      .md-icon {
        color: #fff;
      }
    }
  }

  .underline-right {
    flex-flow: wrap;
  }

  .answer-item {
    display: flex;
    align-items: center;
    padding-bottom: 14px;
    .md-radio {
      margin: 0px 16px 0px 0;
      display: flex;
      align-items: center;
    }

    .tag-list {
      margin-right: 20px;
    }

    .classification-tag {
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      background: #fff;
      padding: 0 12px;
      height: 42px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      white-space: nowrap;
    }

    .underline-tag {
      cursor: pointer;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      background: #fff;
      padding: 0 12px;
      height: 34px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
      margin-right: 8px;
    }

    .underline-tag.selected {
      background: #1cab36;
      color: #fff;
    }
  }

  .matching {
    .col-header {
      padding-top: 12px;
      font-weight: bold;
    }
  }

  .word-search {
    .crossword-row {
      display: flex;
      justify-content: center;
      .crossword-unit {
        width: 50px;
        height: 50px;
      }
    }
  }
}

/* ============================================ */
/* DaDImageLabeling Styles */
/* ============================================ */
.dad-image-labeling {
  .dad-image-container {
    margin-bottom: 16px;
    text-align: center;

    .image-wrapper {
      position: relative;
      display: inline-block;
      max-width: 100%;

      .dad-image {
        max-width: 100%;
        max-height: 500px;
        display: block;
      }

      .label-rect {
        position: absolute;
        border: 2px solid #1890ff;
        background: rgba(24, 144, 255, 0.2);
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .label-text {
          background: #1890ff;
          color: #fff;
          padding: 2px 8px;
          font-size: 12px;
          font-weight: bold;
          border-radius: 3px;
          white-space: nowrap;
        }

        .label-actions {
          position: absolute;
          top: 0;
          right: 0;
          display: none;
          background: rgba(0, 0, 0, 0.7);
          border-radius: 4px;
          padding: 2px;

          .el-button {
            padding: 0 4px;
            height: 20px;
          }
        }

        &:hover .label-actions {
          display: flex;
        }
      }
    }
  }
}

/* ============================================ */
/* FillInTheBlanks Styles */
/* ============================================ */
.fill-in-blanks {
  .fill-blanks-editor {
    .toolbar {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
    }

    .editor-split {
      display: flex;
      gap: 16px;
      margin-bottom: 16px;

      .editor-left {
        flex: 1;

        .section-title {
          font-weight: bold;
          margin-bottom: 8px;
          color: #666;
        }
      }

      .editor-right {
        flex: 1;

        .section-title {
          font-weight: bold;
          margin-bottom: 8px;
          color: #666;
        }

        .preview-content {
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          padding: 12px;
          min-height: 140px;
          background: #fafafa;

          .preview-line {
            margin-bottom: 8px;
            line-height: 2;

            .text-part {
              color: #333;
            }

            .blank-slot {
              display: inline-flex;
              align-items: center;
              gap: 4px;
              min-width: 60px;
              padding: 2px 8px;
              margin: 0 4px;
              background: #e6f7ff;
              border: 1px dashed #1890ff;
              border-radius: 4px;
              color: #1890ff;
              font-weight: 500;

              .blank-number {
                background: #1890ff;
                color: #fff;
                padding: 0 6px;
                border-radius: 3px;
                font-size: 12px;
              }

              .delete-blank-btn {
                padding: 0 2px;
                height: 18px;
                line-height: 1;

                .md-icon {
                  font-size: 14px !important;
                }
              }
            }
          }
        }
      }
    }

    .blanks-answers {
      padding: 12px;
      background: #f5f5f5;
      border-radius: 4px;

      .blanks-title {
        font-weight: bold;
        margin-bottom: 12px;
        color: #1890ff;
      }

      .blank-answer-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .blank-label {
          min-width: 100px;
          font-weight: 500;
          color: #666;
        }
      }
    }
  }

  .fill-blanks-preview {
    .preview-line {
      margin-bottom: 8px;
      line-height: 2;

      .text-part {
        color: #333;
      }

      .blank-slot {
        display: inline-block;
        min-width: 80px;
        padding: 2px 12px;
        margin: 0 4px;
        background: #e6f7ff;
        border: 1px dashed #1890ff;
        border-radius: 4px;
        color: #1890ff;
        font-weight: 500;
        text-align: center;
      }
    }
  }
}
</style>
